import { IModalDescription } from '@cp/shared/modal';
import type { CatalogRelevantItemsModalProps } from '../ui/relevantItemsModal';

export const RELEVANT_CATALOG_ITEMS_MODAL: IModalDescription<CatalogRelevantItemsModalProps> = {
  nss: 'catalog/RELEVANT_CATALOG_ITEMS_MODAL',
  loader: () => import('../ui/relevantItemsModal').then((m) => m.CatalogRelevantItemsModal),
};
